import Vue, { CreateElement } from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ClPaper from '../ClPaper';
import { capitalize } from '../../lib';

export interface Classes {
  [key: string]: any;
  root?: any;
}

export type Color = 'inherit' | 'primary' | 'secondary' | 'default';
export type Position = 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';

@Component
export default class ClAppBar extends Vue {
  @Prop({
    type: Object as () => Classes,
    default: () => ({
      root: '',
      positionFixed: '',
      positionAbsolute: '',
      positionSticky: '',
      positionStatic: '',
      positionRelative: '',
      colorDefault: '',
      colorPrimary: '',
      colorSecondary: ''
    })
  })
  public classes!: Classes;

  @Prop({
    type: String as () => Color,
    default: 'primary'
  })
  public color!: Color;

  @Prop({
    type: Number,
    default: 4
  })
  public elevation!: number;

  @Prop({
    type: String as () => Position,
    default: 'fixed'
  })
  public position!: Position;

  render(h: CreateElement) {
    return (
      <ClPaper
        square
        elevation={this.elevation}
        component="header"
        class={[
          'cl-app-bar',
          `cl-app-bar--position-${this.position}`,
          `cl-app-bar--color-${this.color}`,
          this.classes.root,
          this.classes[`position${capitalize(this.position)}`],
          this.classes[`color${capitalize(this.color)}`]
        ]}
      >
        {this.$slots.default}
      </ClPaper>
    );
  }
}
